<template>
  <CTag v-if="vehicle.registrationNumber" theme="outline" class="c-licence-plate" :class="countryClass">
    {{ vehicle.registrationNumber }}
  </CTag>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import Vehicle from '@/vehicle/models/Vehicle';
  import { KNOWN_COUNTRY_IDS } from '../models/Country';
  import CTag from './CTag.vue';

  const props = defineProps<{
    vehicle: Vehicle
  }>();

  const countryClass = computed(() => {
    switch (props.vehicle.countryId) {
      case KNOWN_COUNTRY_IDS.BELGIUM:
        return 'c-licence-plate-belgium';
      case KNOWN_COUNTRY_IDS.THE_NETHERLANDS:
        return 'c-licence-plate-netherlands';
      case KNOWN_COUNTRY_IDS.LUXEMBOURG:
        return 'c-licence-plate-luxembourg';
      case KNOWN_COUNTRY_IDS.GERMANY:
        return 'c-licence-plate-germany';
    }
  });

</script>

<style lang="scss">
  .c-licence-plate {
    // NOTE: we use specific color values as these are not bound to theming
    color: var(--plate-text-color, black);
    background-color: var(--plate-bg-color, white);
    border-color: var(--plate-border-color, transparent);

    &-belgium {
      --plate-text-color: #FF0F21;
      --plate-border-color: #FF0F21;
    }

    &-netherlands {
      --plate-bg-color: #FFD100;
      --plate-border-color: black;
    }

    &-luxembourg {
      --plate-bg-color: #F3B701;
      --plate-border-color: black;
    }

    &-germany {
      --plate-border-color: black;
    }
  }
</style>
